import { Component, OnInit } from "@angular/core";
import { DialogService } from "src/app/core/core-services/services/dialog.service";
import { MetaService } from "src/app/core/core-services/services/meta.service";
import { SharedDataService } from "src/app/core/core-services/services/shared-data.service";
import { FlyCutInviteComponent } from "../../share/fly-cut-invite/fly-cut-invite.component";
import { Store } from "@ngrx/store";
import { selectPlanData } from "src/app/core/store/plan/plan.selectors";
import { AuthService } from "src/app/core/core-services/services/auth.service";
import { parseReferrals } from "src/app/utils/referrals.util";

@Component({
    selector: "app-flyshare-rewards",
    templateUrl: "./flyshare-rewards.component.html",
    styleUrls: ["./flyshare-rewards.component.scss"],
    standalone: false
})
export class FlyshareRewardsComponent implements OnInit {
  firstPersonSignedUp: any;
  secondPersonSignedUp: any;
  thirdPersonSignedUp: any;
  fourthPersonSignedUp: any;
  // selectPlanData, not `state => state.data`: the root state is { plan: PlanState },
  // so `state.data` is always undefined and the old destructuring subscriber threw.
  currentPlan$ = this.store.select(selectPlanData);

  constructor(
    private readonly dialog: DialogService,
    private readonly sharedData: SharedDataService,
    private readonly authService: AuthService,
    private readonly metaService: MetaService,
    private readonly store: Store,
  ) { }

  ngOnInit(): void {
    this.currentPlan$
      .subscribe((currentPlan) => {
        if (currentPlan?.referrals) {
          const { people } = parseReferrals(currentPlan.referrals);
          [this.firstPersonSignedUp, this.secondPersonSignedUp, this.thirdPersonSignedUp, this.fourthPersonSignedUp] =
            people;
        }

        if (currentPlan?.referral_key && currentPlan?.referral_key != this.authService.userDetails?.user_details?.referral_key) {
          const user = {
            ...this.authService.userDetails,
            user_details: {
              ...this.authService.userDetails?.user_details,
              referral_key: currentPlan?.referral_key,
            },
          };
          this.authService.saveUserDetail(user);
        }
      }
      );

    this.metaService.addMetaTag(
      'FlyMSG Rewards Page',
      "Share the love and earn rewards when you refer others to FlyMSG and they sign up! Help them to save 1-hour a day too!");
  }

  inviteMore(): void {
    this.dialog.openDialogComponent(FlyCutInviteComponent, { parentPage: 'subscription' }, "859px");
  }
}
